module.exports = __webpack_public_path__ + "media/flags/sk-5bb982ad.svg";